<template>
  <modal name="video" height="auto" :pivotX="windowWidth > 620 ? 0 : 0.5" :pivotY=".15" @before-open="assignParams">
    <aside class="window window--full-width">
      <header class="window__header">
        <h1 class="window__title">{{ title }}</h1>
      </header>
      <section class="window__content">
        <iframe :src="video_url" :width="windowWidth > 621 ? 500 : 350" height="300px" allowfullscreen frameborder="0" class="video__player"></iframe>
      </section>
      <footer class="window__footer">
        <div class="button button--secondary button--expand" @click="hide">Close Video</div>
      </footer>
    </aside>
  </modal>
</template>

<script>
export default {
  name: 'Video',
  data () {
    return {
      title: 'Parkave',
      video_url: 'https://www.youtube.com/embed/QBTH4aF9vJ0',
      windowWidth: window.innerWidth
    }
  },
  computed: {
    browserWidth() {
      return document.body.offsetWidth
    }
  },
  methods: {
    assignParams (event) {
        this.title = event.params.title;
        this.video_url = event.params.video;
    },
    hide() {
        this.$modal.hide('video');
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>

<style scoped>
  .video__player {
    position: relative;
    margin: 20px auto;
    left: 50%;
    transform: translateX(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/Video.vue